import { UseStateType } from "@relode/core";
import * as React from "react";

const JobsContext = React.createContext(undefined);

export const JobsProvider = (props: { children?: React.ReactNode }) => {
    const [ids, setIds] = React.useState<number[]>([]);
    const value = React.useMemo(() => [ids, setIds], [ids]) as UseStateType<
        number[]
    >;
    return <JobsContext.Provider value={value} {...props} />;
};
